import axios, { AxiosResponse } from 'axios'
import { appStore } from '../../store/jotai.store'
import { markApiLoaded } from '../stores/loader-tracking.store'

let isSetup = false

/**
 * Setup axios interceptor to track initial API loading progress
 */
export const setupLoaderTrackingInterceptor = () => {
    // Prevent duplicate interceptor setup
    if (isSetup) {
        console.log('[GLIC2027 LoaderTracking] Interceptor already setup, skipping')
        return
    }
    isSetup = true

    // Response interceptor - mark API as loaded when response is received
    axios.interceptors.response.use(
        (response: AxiosResponse) => {
            const url = response.config.url || ''

            // Mark this API as loaded in the tracking store
            appStore.set(markApiLoaded, url)

            return response
        },
        error => {
            // Even on error, mark as loaded (to not block the loader indefinitely)
            const url = error.config?.url || ''

            if (url) {
                appStore.set(markApiLoaded, url)
            }

            return Promise.reject(error)
        }
    )

    console.log('[GLIC2027 LoaderTracking] ✅ Interceptor setup complete')
}
